import React from "react";
import "./styles.css";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Checkbox from "@material-ui/core/Checkbox";
import Collapse from "@material-ui/core/Collapse";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import {useDispatch, useSelector} from "react-redux";
import {domain} from "../App";
import {notifyerror} from "../Utility/Notification";
const rows = [{ address: "sdaaa",
    description: "ac nhi chal rhaa and garam hva fek rha h",
    addedby: {_id: "5f5a072b90a1c7001793940f",
        city: "Bhopal",
        mobile: 9669555126,
        name: "Nikhil Tale",
        pin: 233344
    },
    isactive: true,
    work: "asd",
    __v: 0,
    _id: "5f5a12f181633d193cf2c970"}];
function Row(props) {
    const { row,completed } = props;
    const [open, setOpen] = React.useState(false);
    const dispatch = useDispatch();
    const freedata = useSelector((state) => state.professional.free);
    const userid = useSelector((state) => state.user.user.professional._id);
    const jwt = useSelector((state) => state.auth.jwt);

    const handleClick = (row) => {
        console.log(row);
        const article = JSON.stringify({
            userid: userid,
            request: row,
        });

        let xhr = new XMLHttpRequest();
        xhr.open("PUT", `${domain}/pickrequest`);
        xhr.setRequestHeader("Content-type", "application/json; charset=utf-8");
        xhr.setRequestHeader("Authorization", "Bearer " + jwt);

        xhr.send(article);
        xhr.onload = () => {
            const data = JSON.parse(xhr.response);
            if (data.error) {
                notifyerror(data.error);
            } else {
                // console.log(data);
                dispatch({ type: "PENDING", payload: data.requests.pendingrequest });
            }
        };
    };


    return (
        <React.Fragment>
            <TableRow>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell component="th" scope="row">
                    {row.addedby.name}
                </TableCell>
                <TableCell align="right">{row.work}</TableCell>
                <TableCell align="right">
                    {completed?rows.rating:<Checkbox name="checkedB" color="#46516d" onClick={(e) => {
                        handleClick(row);
                        e.target.parentElement.classList.add("picked")
                    }}/>}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Details
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom component="div">
                                Address
                            </Typography>
                            <Typography variant="body2" gutterBottom component="div">
                                {row.address}
                            </Typography>
                            <Typography variant="subtitle1" gutterBottom component="div">
                                Description
                            </Typography>
                            <Typography variant="body2" gutterBottom component="div">
                                {row.description}
                            </Typography>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}


const ProfessionalTable = ({ completed, data }) => {
  console.log(data);
  return (
      <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
              <TableHead >
                  <TableRow>
                      <TableCell />
                      <TableCell>Name</TableCell>
                      <TableCell align="right">Work</TableCell>
                      <TableCell align="right">{completed?"rating":'mark completed'}</TableCell>
                  </TableRow>
              </TableHead>
              <TableBody>
                  {rows.map((row) => (
                      <Row key={row.name} row={row} completed={completed}/>
                  ))}
              </TableBody>
          </Table>
      </TableContainer>

  );
};

export default React.memo(ProfessionalTable);
